import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../assets/component/Layout";
import { Container } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import axios from "axios";
import AddUserModal from "../assets/component/AddUserModal";

const BASE_URL = process.env.REACT_APP_API_URL

export default function AllUsers() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Fetch users from backend
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${BASE_URL}list-Users`, {
          headers: {
            Authorization: token,
          },
        });
        setUsers(response.data?.data?.users);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching users:", err);
        setError("Failed to fetch users.");
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return (
    <Layout>
      <section className="Inner-page-layout">
        <div className="">
          <Container>
            <div className="adding-buttom">
              <h1 className="mb-0">All Users</h1>
              <button onClick={handleShow}>Add User</button>
            </div>
          </Container>

          <div className="engineers-forms-table adding-p-t">
            <Container>
              {loading ? (
                <p>Loading users...</p>
              ) : error ? (
                <p className="text-danger">{error}</p>
              ) : (
                <Table>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users?.length ? users.map((user, index) => (
                      <tr key={user.id || index}>
                        <td>{index + 1}</td>
                        <td>{user.name}</td>
                        <td>
                          <Form.Select aria-label="User status select" disabled value={user?.account_status}>
                            <option value="pending">Pending</option>
                            <option value="blocked">Block</option>
                            <option value="Active">Active</option>
                          </Form.Select>
                        </td>
                      </tr>
                    )) : null}
                  </tbody>
                </Table>
              )}
            </Container>
          </div>
        </div>
      </section>

      <AddUserModal show={show} handleClose={handleClose} />
    </Layout>
  );
}
